// extracted by mini-css-extract-plugin
export default {"null":"NullItem_null__bNDx2"};